import {Component, computed, DestroyRef, effect, inject, Input, input} from '@angular/core';
 
import {CommonModule} from '@angular/common';
import {LanguageService} from '@core/service/language.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
 
@Component({
  standalone: true,
  selector: 'tmw-label',
  template: `{{ value }}`,
  imports: [CommonModule],
})
export class TmwI18NLabelComponent {
  private readonly destroy: DestroyRef = inject(DestroyRef);
  private languageService: LanguageService = inject(LanguageService);
 
  @Input() object!: any;
  @Input() field!: string;
  @Input() fieldAr?: string;
  @Input() defaultValue: string = '-';
  @Input() abbreviate: number = 0;
  @Input() ellipsis: string = '...';
  value: string = this.defaultValue;
  lang: string = this.languageService.currentLang$.value;
 
  ngOnInit() {
    if(!this.fieldAr) {
      this.fieldAr = this.field +'Ar';
    }
    this.languageService
      .getCurrent()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((lang) => {
        this.lang = lang;
        this.updateValue();
      });
  }
 
  updateValue() {
    if(this.object) {
        if(this.lang =='ar') {
          this.value = this.object[this.fieldAr!] || this.object[this.field] || this.defaultValue
        } else {
          this.value = this.object[this.field] || this.defaultValue
        }
        if (this.abbreviate > 0 && this.value.length > this.abbreviate) {
          this.value = this.value.substring(0, this.abbreviate) + this.ellipsis;
        }
        }
    }
  }

 
